import React from 'react';
import { About, Description, Image } from '../styles';
import styled from 'styled-components';
//Images
import homeImg1 from '../img/home1.jpg';
import { titleAnim, fade, photoAnim } from '../animation';
import { motion } from 'framer-motion';
import Wave from './Wave';

const AboutSection = () => {
  return (
    <About>
      <Description>
        <div className="title">
          <Hide>
            <motion.h2 variants={titleAnim}> <span> I work </span> to make</motion.h2>
          </Hide>
          <Hide>
            <motion.h2 variants={titleAnim}>
              the best <span>Pasta</span> 
            </motion.h2>
          </Hide>
          <Hide>
            <motion.h2 variants={titleAnim}>there is.</motion.h2>
          </Hide>
        </div>
        <motion.p variants={fade}>
        Welcome to My Porofolio , My Name is Chef Abdelsamad And My Nickname is Chef Doo, I Love Making Pasta, If You Are Interested Feel Free to Contact Me.
        </motion.p>
        <motion.button variants={fade}>Contact Me</motion.button>
      </Description>
      <Image>
        <motion.img variants={photoAnim} src={homeImg1} alt="camera guy" />
      </Image>
      <Wave />
    </About>
  );
};

const Hide = styled.div`
  overflow: hidden;
`;

export default AboutSection;
